interface Testimonial {
  name: string;
  zip: string;
  tag: string;
  quote: string;
}

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}

export default function TestimonialsSection({ testimonials }: TestimonialsSectionProps) {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-[#064e3b] text-3xl md:text-4xl font-black text-center mb-12">
          What Brickell Homeowners Say
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#fefce8] border border-[#064e3b]/10 p-6">
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, s) => (
                  <i key={s} className="ri-star-fill text-[#fbbf24] text-sm" />
                ))}
                <span className="text-xs text-[#047857] font-bold ml-2 bg-[#047857]/10 px-2 py-0.5">Verified</span>
              </div>
              <p className="text-[#444444] text-sm leading-relaxed mb-6 italic">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#064e3b] text-white flex items-center justify-center text-sm font-bold">
                  {t.name.split(" ").map(n => n[0]).join("")}
                </div>
                <div>
                  <div className="text-sm font-bold text-[#1a1a1a]">{t.name}</div>
                  <div className="text-xs text-[#666666]">{t.zip} — {t.tag}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}